import logo from './logo.png';
import unibenlogo from './uniben-logo.png';
import { Link } from 'react-router-dom';
import './LandingPage.css'; // shared look for all JTVET pages
// import { useState, useEffect } from 'react';
// import axios from 'axios';

const ISSUE_LABEL = 'Volume 1, Number 1, August 2025';
const PDF_FOLDER = '/jtvet vol1_1/';

// One entry per article. Add new articles here; the list renders itself.
const articles = [
  {
    title: 'Assessment of STEM student’s Technological Literacy on the societal impact of technology in Federal College of Education (Technical), Asaba, Delta State',
    authors: 'Justin Afolabi Okhueleigbe, Obed Obinna Okoh, Dare Micheal Ogunyemi',
    file: 'afolabi (1).pdf',
  },
  {
    title: 'Assessing Primary Education Response To Global Economic Challenges And Implementation Of Sustainable Development Goal (8) In Rivers State Of Nigeria',
    authors: 'Onisofien Stanley Opuwari Uzoigwe, Michael Chukwudi',
    file: 'ASSESSING PRIMARY EDUCATION RESPONSE .....-1.pdf',
  },
  {
    title: 'Digital Skills and Artificial Intelligence in Education',
    authors: 'Beatrice Ezekiel-Hart',
    file: 'Beatrice Ezekiel-Hart.pdf',
  },
  {
    title: 'Building Technology: For Global Security, Economic Transformation, and Development',
    authors: 'Briska Sulisari Solomon, Giwa Musibau, Bala Anthony Gora, & Osakue E. Felicia',
    file: 'briska.pdf',
  },
  {
    title: 'The Roles of Parents in Technical Education of Children in Delta State, Nigeria',
    authors: 'Oluwalowo Idowu Ayodele',
    file: 'Idowu.pdf',
  },
  {
    title: 'Integrating Emerging Technologies In Christian Religious Studies: Impacts, Challenges, And Way Forward For National Development',
    authors: 'David Moses Nkut',
    file: 'INTEGRATING EMERGING TECHNOLOGIES IN CHRISTIAN RELIGIOUS STUDIE1-1.pdf',
  },
  {
    title: 'Perceived Importance of Industry Feedback in TVET Curriculum Development: An Ordered Logistic Regression Analysis of Sampled Nigerian TVET Lecturers',
    authors: 'Korter Grace, Lawal Praise, Obafemi Babatunde & King Korter',
    file: 'Korter Grace.pdf',
  },
  {
    title: 'Bridging the Skills Gap: TVET’s Role in Solving Youth Unemployment in Nigeria',
    authors: 'Okakpu Arinze Aloysius',
    file: 'mr arinze.pdf',
  },
  {
    title: 'Skills Needed for Operating Tungsten Inert Gas Welding in Small and Medium Scale Welding Shops in Kaduna State',
    authors: 'Josiah Bitrus Dantawaye',
    file: 'mr datawaye.pdf',
  },
  {
    title: 'Empowering Sustainable Development through Effective Language Education',
    authors: 'Mary Ann Nnenne Chukwurah',
    file: 'mrs chukwurah-1.pdf',
  },
  {
    title: 'Repositioning Technical Vocational Education and Training for Enhanced Employable Skills as a Panacea for Security Challenges in Nigeria',
    authors: 'Gladys Ibiene Igbokwe',
    file: 'MRS IGGOKWE (PAPER NOV) 2024 2.pdf',
  },
  {
    title: 'Integrating Digital Skills and Artificial Intelligence in Metalwork Education',
    authors: 'Babatunde Habeed Wahab, Abdulrasak Aliyu, Asundi B. Patrick',
    file: 'NEWINTEGRATING DIGITAL SKILLS AND ARTIFICIAL INTELLIGENCE IN METALWORK EDUCATION.pdf',
  },
  {
    title: 'Innovative Technology in Education: The Roles of Art Teachers in Motivating Child Art Education',
    authors: 'Umar Olaitan Salihu',
    file: 'Umar Olaitan, Salihu.pdf',
  },
  {
    title: 'Availability and Utilisation of Educational Materials in Private Secondary School in Oredo Local Government Area of Edo State',
    authors: 'Regina Oghenerie Okwe, Marcel Chimezie Diwe',
    file: 'mrs okowe .pdf',
  },
  {
    title: 'Quality Supervision in Technology and Vocational Education: A Catholicon for Sustainable National Development',
    authors: 'Bala Anthony Gora, Giwa Musibau, Osakue E. Felicia, Briska Sulisari Solomon',
    file: 'Bala Anthony Gora.pdf',
  },
  {
    title: 'Responsive Skill Training for Employability and Sustainability for Global Economic Setting',
    authors: 'Ijwo Joel Ega, Adekola Yunisha Adekola, Oluwalowo Idowu',
    file: '11 RESPONSIVE SKILL TRAINING FOR EMPLOYABILITY IN GLOBAL SETTING 1.pdf',
  },
  {
    title: 'Electric Field Distribution in the Human Head: Computational Modeling Across 1–3 Ghz For 5g Applications',
    authors: 'Blessing Yokk John, Vincent J. Aimayo',
    file: 'Aimayo and Blessing.pdf',
  },
];

function PublishedArticles() {
  return (
    <div className="jt-page">
      <a className="jt-skip" href="#main">Skip to content</a>

      {/* Header */}
      <header className="jt-header">
        <div className="jt-header__inner">
          <div className="jt-brand">
            <div className="jt-brand__logos">
              <img src={logo} alt="JTVET logo" />
              <img src={unibenlogo} alt="University of Benin logo" />
            </div>
            <div>
              <p className="jt-brand__name">JTVET</p>
              <p className="jt-brand__sub">Nigerian Research Journal</p>
            </div>
          </div>

          <nav className="jt-nav" aria-label="Primary">
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/published">Published manuscripts</Link></li>
              <li><Link to="/submit" className="jt-nav__cta">Submit manuscript</Link></li>
            </ul>
          </nav>
        </div>
      </header>

      <main id="main">
        {/* Issue heading */}
        <section className="jt-hero">
          <div className="jt-hero__inner jt-hero__inner--single">
            <div className="jt-hero__text">
              <h1>Current issue</h1>
              <p className="jt-hero__lead">{ISSUE_LABEL}</p>
            </div>
          </div>
        </section>

        {/* Article list */}
        <section className="jt-section">
          <h2>Articles in this issue</h2>
          <p className="jt-issue__count">{articles.length} articles, open access</p>

          <ul className="jt-articles">
            {articles.map((article) => (
              <li key={article.file}>
                <div>
                  <h3>{article.title}</h3>
                  <p className="jt-articles__authors">{article.authors}</p>
                </div>
                <a
                  href={encodeURI(PDF_FOLDER + article.file)}
                  download
                  className="jt-btn jt-btn--ghost jt-btn--small"
                  aria-label={`Download article: ${article.title}`}
                >
                  Download PDF
                </a>
              </li>
            ))}
          </ul>
        </section>
      </main>

      {/* Footer */}
      <footer className="jt-footer">
        <div className="jt-footer__inner">
          <p>
            Copyright © 2026 Journal of Technical and Vocational Education and
            Training. All rights reserved.
          </p>
          <p>
            Designed and developed by <span>ISITEC</span>
          </p>
        </div>
      </footer>
    </div>
  );
}

export default PublishedArticles;
